import FormInput from 'components/Input/FormInput';
import React from 'react';

interface IScheduleInput {
	changeSchedule: (value: string) => void;
}

const ScheduleInput: React.FC<IScheduleInput> = ({ changeSchedule }) => {
	return (
		<FormInput
			testId="ScheduleInput"
			name="schedule"
			label="activationScheduleLabel"
			placeholder="cronExpressionInputPlaceholder"
			maxLength={128}
			onChange={changeSchedule}
		/>
	);
};

export default React.memo(ScheduleInput);
